import React, { useState } from 'react';
import ModalShell from '../ModalShell/ModalShell';
import { useI18n } from '../../i18n/I18nContext';
import PasswordInput from '../PasswordInput/PasswordInput';
import './SensitiveAccessModal.css';

interface SensitiveAccessModalProps {
  loading: boolean;
  usernameValue?: string;
  onClose: () => void;
  onSubmit: (password: string) => Promise<void>;
}

const SensitiveAccessModal: React.FC<SensitiveAccessModalProps> = ({ loading, usernameValue, onClose, onSubmit }) => {
  const { t } = useI18n();
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit() {
    if (!password.trim()) {
      setError(t('profile.requireCurrentPassword'));
      return;
    }
    setError(null);
    try {
      await onSubmit(password);
      onClose();
    } catch (nextError) {
      setError(nextError instanceof Error ? nextError.message : t('login.error'));
    }
  }

  return (
    <ModalShell onClose={onClose} ariaLabel={t('auth.sensitiveTitle')} className="modal sensitive-access-modal">
      <h3 style={{ marginTop: 0 }}>{t('auth.sensitiveTitle')}</h3>
      <p className="sensitive-access-description">{t('auth.sensitiveDescription')}</p>
      <form
        onSubmit={(event) => {
          event.preventDefault();
          void handleSubmit();
        }}
      >
        {error ? <div className="sensitive-access-error">{error}</div> : null}
        <label>{t('auth.sensitivePassword')}</label>
        <PasswordInput
          className="sensitive-access-password-input"
          inputClassName="sensitive-access-input"
          value={password}
          onChange={setPassword}
          usernameValue={usernameValue}
          autoComplete="current-password"
        />
        <div className="sensitive-access-actions">
          <button type="button" className="secondary-button" onClick={onClose}>
            {t('auth.cancel')}
          </button>
          <button type="submit" className="sensitive-access-submit" disabled={loading}>
            {t('auth.continue')}
          </button>
        </div>
      </form>
    </ModalShell>
  );
};

export default SensitiveAccessModal;
